import Vue from "vue"
import Cropper from "cropperjs"
import "cropperjs/dist/cropper.css"

Vue.component("Cropper", Cropper)

export default Cropper
